export const EDIT_SUCCESS = 'Группа клиентов обновлена';
export const EDIT_ERROR = 'Не удалось обновить группу клиентов';
